<p class="utrecht-paragraph utrecht-form-field__label">
  <label
    class="utrecht-form-label utrecht-form-label--openforms {{ctx.label.className}} {% if (ctx.component.validate.required && ctx.requiredFieldsWithAsterisk) { %}utrecht-form-label--openforms-required{% } %}"
    for="{{ctx.instance.id}}-{{ctx.component.key}}"
    {% if (ctx.component.suffix) { %}
      id="label-{{ctx.instance.id}}-{{ctx.component.key}}"
    {% } %}
  >
    {{ ctx.t(ctx.component.label, { _userInput: true }) }}
    {% if (!ctx.component.validate.required && !ctx.requiredFieldsWithAsterisk) { %}
      {{ ctx.t('(not required)') }}
    {% } %}
    {% if (ctx.component.tooltip) { %}
      <i ref="tooltip" class="openforms-tooltip-icon {{ctx.iconClass('question-sign')}}" data-tooltip="{{ ctx.tooltip }}"></i>
    {% } %}
  </label>
</p>
